import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M25.0791,15.6 L5.25,15.6 C4.8357,15.6 4.5,15.2643 4.5,14.85 C4.5,14.4357 4.8357,14.1 5.25,14.1 L25.0791,14.1 C25.4934,14.1 25.8291,14.4357 25.8291,14.85 C25.8291,15.2643 25.4934,15.6 25.0791,15.6" />
  </React.Fragment>,
  'Clear'
)
